// Dedicated Web Audio API manager for zero-latency sound effects and gapless looping.
// Owns the shared AudioContext + decoded buffer cache. Must not import state.js —
// it runs its side effects (preloads, unlock listeners) at module evaluation.

export const audioCtx = new (window.AudioContext || (window as any).webkitAudioContext)();
const buffers = new Map<string, AudioBuffer>();

export function getBuffer(name: string): AudioBuffer | undefined {
  return buffers.get(name);
}

export function loadAudio(name: string, url: string) {
  fetch(url)
    .then((res) => res.arrayBuffer())
    .then((data) => audioCtx.decodeAudioData(data))
    .then((buffer) => buffers.set(name, buffer))
    .catch((e) => console.warn(`Failed to load audio: ${name}`, e));
}

// Preload sound effects into memory
loadAudio("pew", "/pew.ogg");
loadAudio("explosion", "/explosion.ogg");
loadAudio("vroom", "/vroom.ogg");
loadAudio("reloading", "/reloading.ogg");
loadAudio("powerup", "/powerup.ogg");
loadAudio("oof", "/oof.ogg");
loadAudio("first_blood", "/first_blood.ogg");
loadAudio("double_kill", "/double_kill.ogg");
loadAudio("triple_kill", "/triple_kill.ogg");
loadAudio("maniac", "/maniac.ogg");
loadAudio("savage", "/savage.ogg");
loadAudio("win", "/win.ogg");
loadAudio("lose", "/lose.ogg");
loadAudio("bgm", "/bgm.ogg");

// Browsers require a user gesture to unlock audio contexts
const unlockAudio = () => {
  if (audioCtx.state === "suspended") audioCtx.resume();
  document.removeEventListener("pointerdown", unlockAudio);
  document.removeEventListener("keydown", unlockAudio);
};
document.addEventListener("pointerdown", unlockAudio);
document.addEventListener("keydown", unlockAudio);
